import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import stylesDesktop from './AccountNavDesktop.module.css';
import stylesMobile from './AccountNavMobile.module.css';
import { ReactComponent as MenuMobileIcon } from 'icons/menu_mobile.svg';
import useBreakpoint from 'hooks/useBreakpoint';
import { useAuth } from 'contexts/AuthContext';
import useAccessibility from 'hooks/useAccessibility';
import { useCart } from 'contexts/CartContext';

const AccountNav = React.forwardRef(({ onClick }, ref) => {


  const { selectedOption } = useAccessibility();


  useEffect(() => {
    console.log("selectedOption", selectedOption);

  }, [selectedOption]);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 991);
  const [openNav, setOpenNav] = useState(false);
  const [selectedItem, setSelected] = useState("informations");

  const { logout } = useAuth();
  const { emptyCart } = useCart();

  useEffect(() => {
    const handleResize = () => {
      window.requestAnimationFrame(() => {
        setIsMobile(window.innerWidth <= 991);
      });
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const styles = isMobile ? stylesMobile : stylesDesktop;


  const AccountNav = [
    {
      title: 'Mes informations',
      onClick: () => {
        onClick('informations')
        setSelected('informations');
        setOpenNav(!openNav);
      },
      key: 'informations',
    },
    {
      title: 'Mes adresses de facturation',
      onClick: () => {
        onClick('adresses')
        setSelected('adresses');
        setOpenNav(!openNav);
      },
      key: 'adresses',
    },
    {
      title: 'Mes réservations',
      onClick: () => {
        onClick('reservations')
        setSelected('reservations');
        setOpenNav(!openNav);
      },
      key: 'reservations',
    },
    {
      title: 'Mes billets',
      onClick: () => {
        onClick('billets')
        setSelected('billets');
        setOpenNav(!openNav);
      },
      key: 'billets',
    },
    {
      title: 'Mes streams',
      onClick: () => {
        onClick('streams')
        setSelected('streams');
        setOpenNav(!openNav);
      },
      key: 'streams',
    },
    {
      title: 'Se déconnecter',
      onClick: () => {
        setOpenNav(!openNav);
        emptyCart();
        logout();
        window.location.href = '/login';
      },
      key: 'deconnexion',
    },
  ]


  return (
    <div className={styles.accountNav} ref={ref}>
      <ul className={`${styles.accountNavList} ${selectedOption === "blackTheme" ? styles.dark : "gfgf"}`}>
        {AccountNav.map((item, index) =>
          <li 
            className={`${styles.accountNavItem} ${item.key === selectedItem ? styles.selected : ''} ${openNav ? styles.openNav : ''}`} 
            key={index} 
            onClick={item.onClick}
            role="button"
            aria-label={`Accéder à la section ${item.title.toLowerCase()}`}
            tabIndex="0"
          >
            {item.title}
          </li>
        )}
      </ul>
    </div>
  )

});

AccountNav.propTypes = {
  onClick: PropTypes.func.isRequired,  // Fonction déclenchée lors du clic
};

export default AccountNav;
